import { InstalarRedaccionPaginas } from "@/util/telemetria-paginas";

/*
 * Las opciones de vue-application-insights que no son la llave ni el router. Viven aparte de
 * main.js para que las pruebas instalen el plugin exactamente como la app (P3-I431).
 *
 * Es una función porque el plugin escribe instrumentationKey dentro de appInsightsConfig: cada
 * llamada regresa un objeto nuevo.
 */
export function OpcionesAppInsights() {
  return {
    appInsightsConfig: {
      accountId: "-1",
      loggingLevelConsole: 2,
      autoTrackPageVisitTime: true,
    },
    accountId: -1,
    // Las vistas de página salen sin query string ni parámetros de la ruta (el regreso de MSAL
    // trae code, state, client_info y session_state en la URL).
    onAfterScriptLoaded: InstalarRedaccionPaginas,
  };
}

export default OpcionesAppInsights;
